/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A DIP created from a Transfer
 * @export
 * @interface ListedDIP
 */
export interface ListedDIP {
    /**
     * Identifier of DIP
     * @type {string}
     * @memberof ListedDIP
     */
    id: string;
    /**
     * Security grading
     * @type {string}
     * @memberof ListedDIP
     */
    securityGrading: ListedDIPSecurityGradingEnum;
    /**
     * Sensitivity classification
     * @type {string}
     * @memberof ListedDIP
     */
    sensitivityClassification: ListedDIPSensitivityClassificationEnum;
    /**
     * Transfer batch number
     * @type {string}
     * @memberof ListedDIP
     */
    transferBatchNumber: string;
    /**
     * Transfer date
     * @type {Date}
     * @memberof ListedDIP
     */
    transferDate?: Date;
    /**
     * Identifier of transfer
     * @type {string}
     * @memberof ListedDIP
     */
    transferId: string;
    /**
     * Transferring agency
     * @type {string}
     * @memberof ListedDIP
     */
    transferringAgency: string;
}


/**
 * @export
 */
export const ListedDIPSecurityGradingEnum = {
    Confidential: 'Confidential',
    ConfidentialCloudEligible: 'Confidential (Cloud-Eligible)',
    Restricted: 'Restricted',
    OfficialClosed: 'Official (Closed)',
    OfficialOpen: 'Official (Open)',
    Secret: 'Secret',
    Unclassified: 'Unclassified',
    Undefined: 'Undefined'
} as const;
export type ListedDIPSecurityGradingEnum = typeof ListedDIPSecurityGradingEnum[keyof typeof ListedDIPSecurityGradingEnum];

/**
 * @export
 */
export const ListedDIPSensitivityClassificationEnum = {
    Undefined: 'Undefined',
    NonSensitive: 'Non-Sensitive',
    SensitiveNormal: 'Sensitive Normal',
    SensitiveHigh: 'Sensitive High'
} as const;
export type ListedDIPSensitivityClassificationEnum = typeof ListedDIPSensitivityClassificationEnum[keyof typeof ListedDIPSensitivityClassificationEnum];


/**
 * Check if a given object implements the ListedDIP interface.
 */
export function instanceOfListedDIP(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "securityGrading" in value;
    isInstance = isInstance && "sensitivityClassification" in value;
    isInstance = isInstance && "transferBatchNumber" in value;
    isInstance = isInstance && "transferId" in value;
    isInstance = isInstance && "transferringAgency" in value;

    return isInstance;
}

export function ListedDIPFromJSON(json: any): ListedDIP {
    return ListedDIPFromJSONTyped(json, false);
}

export function ListedDIPFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListedDIP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'securityGrading': json['security_grading'],
        'sensitivityClassification': json['sensitivity_classification'],
        'transferBatchNumber': json['transfer_batch_number'],
        'transferDate': !exists(json, 'transfer_date') ? undefined : (new Date(json['transfer_date'])),
        'transferId': json['transfer_id'],
        'transferringAgency': json['transferring_agency'],
    };
}

export function ListedDIPToJSON(value?: ListedDIP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'security_grading': value.securityGrading,
        'sensitivity_classification': value.sensitivityClassification,
        'transfer_batch_number': value.transferBatchNumber,
        'transfer_date': value.transferDate === undefined ? undefined : (value.transferDate.toISOString().substr(0,10)),
        'transfer_id': value.transferId,
        'transferring_agency': value.transferringAgency,
    };
}

